// extracted by mini-css-extract-plugin
export default {"description":"description--FZMhb","description__brand":"description__brand--haZK5","description__name":"description__name--RGSu4","separator":"separator--QTMfv"};